import { SessionStorageState } from '../../../types/context';

export const getDataFromSessionStorage = (localStorageKey: string) => {
  const data = window.sessionStorage.getItem(localStorageKey) || '{}';
  const parsed: SessionStorageState = JSON.parse(data);
  return parsed;
};
